export default __webpack_public_path__ + "static/about4-a66665d5f7e7e148d4f29a94847f0e68.jpg";